import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SubAgentPayload } from "app/types/service-types/AgentTypes";

export const subAgentInitialState = (): SubAgentPayload => ({
  fullName: "",
  email: "",
  contactEmail: "",
  location: "",
  phoneNumber: "",
  password: "",
  address: "",
  subAgentName: "",
  subAgentSurname: "",
  invoiceText: "",
  invoiceBottomText: "",
  maxAdultAllowed: 0,
  maxChildAllowed: 0,
  maxInfantAllowed: 0,
  allowInfantOnly: false,
  provisionFormType: "PERCENTAGE",
  discountType: "ALLOW_DISCOUNT",
  balanceRequests: [],
  allowedDiscount: 0,
  actualDebt: "",
  debtBeforeEnding: "",
  scopes: ["FLIGHT_RESERVATION"],
  status: true,
  companyName: "",
  isOperatorLogo: true,
  provisionForms: [],
  discounts: [],
});

const subAgentFormSlice = createSlice({
  name: "subAgentForm",
  initialState: subAgentInitialState(),
  reducers: {
    setSubAgentForm: (_s, a: PayloadAction<SubAgentPayload>) => a.payload,
    patchSubAgentForm: (s, a: PayloadAction<Partial<SubAgentPayload>>) => ({ ...s, ...a.payload }),
    resetSubAgentForm: () => subAgentInitialState(), // <- always new object
  },
});

export const { setSubAgentForm, patchSubAgentForm, resetSubAgentForm } = subAgentFormSlice.actions;
export default subAgentFormSlice.reducer;
